module.exports = __webpack_public_path__ + "img/s1_img.0b4d21b9.png";